(function(){
  var home = document.querySelector('.ks-home');
  if (!home) return;
  // slideshow
  var slides = home.querySelectorAll('.ks-slide'), dots = home.querySelectorAll('.ks-dot'), cur = 0, timer = null, slider = home.querySelector('.ks-slider');
  function go(n){
    slides[cur].classList.remove('is-active'); dots[cur].classList.remove('is-active');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('is-active'); dots[cur].classList.add('is-active');
    var im = slides[cur].querySelectorAll('img[loading="lazy"]'); im.forEach(function(i){ i.loading = 'eager'; });
  }
  function start(){ stop(); timer = setInterval(function(){ go(cur + 1); }, 6500); }
  function stop(){ if (timer) clearInterval(timer); timer = null; }
  dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.getAttribute('data-go')); start(); }); });
  if (slider){
    slider.addEventListener('mouseenter', stop); slider.addEventListener('mouseleave', start);
    var x0 = null;
    slider.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    slider.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40){ go(cur + (dx < 0 ? 1 : -1)); start(); } x0 = null; }, {passive:true});
  }
  // preload slide 2 after load
  window.addEventListener('load', function(){ setTimeout(function(){ if (slides[1]) slides[1].querySelectorAll('img').forEach(function(i){ i.loading = 'eager'; }); }, 1500); });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  // reveal on scroll
  var els = home.querySelectorAll('.ks-anim');
  if ('IntersectionObserver' in window){
    var ob = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); ob.unobserve(e.target); } }); }, {threshold: 0.08, rootMargin: '0px 0px -40px 0px'});
    els.forEach(function(el){ ob.observe(el); });
  } else { els.forEach(function(el){ el.classList.add('is-in'); }); }
  // pause the other film when one plays
  var vids = home.querySelectorAll('.ks-video video');
  vids.forEach(function(v){ v.addEventListener('play', function(){ vids.forEach(function(o){ if (o !== v) o.pause(); }); }); });
})();
